import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/core/services/administration/user.service';
import { CorporateIdentitySettingsService } from 'src/core/services/settings/corporate-identity-settings.service';

@Component({
  selector: 'app-ai-disclaimer-modal',
  templateUrl: './ai-disclaimer-modal.component.html',
  styleUrls: ['./ai-disclaimer-modal.component.scss'],
  standalone: false,
})
export class AIDisclaimerModalComponent implements OnInit {
  disclaimerText: string = '';
  isLoading = true;

  constructor(
    public activeModal: NgbActiveModal,
    private userService: UserService,
    private corporateIdentitySettingsService: CorporateIdentitySettingsService,
  ) {}

  ngOnInit(): void {
    this.corporateIdentitySettingsService.get().subscribe({
      next: result => {
        this.disclaimerText = result.aiUsageDisclaimerText ?? '';
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  close(): void {
    this.userService.setConfirmedAiUsageDisclaimer().subscribe(() => {
      this.activeModal.close();
    });
  }
}
